import { gql } from "@apollo/client";

export const userFragment = gql(/* GraphQL */ `
  fragment UserFragment on User {
    id
    name
    email
    lastName
    firstName
  }
`);
